import Url from 'url-parse'

export function parseUrl(url?: string) {
  return url
    ? new Url(/^https?:\/\//.test(url) ? url : `http://${url}`)
    : undefined
}
